import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const SelectChildrenForRoom = React.lazy(() => import('./select-children-for-room').then(module => ({ default: module.SelectChildrenForRoom })));
/** Only sites with the feature reach this screen, so it loads on demand */
export const SelectChildInRoomRoute = () => (_jsx(React.Suspense, { fallback: null, children: _jsx(SelectChildrenForRoom, {}) }));
